// Renders the control_checks.py::run_control_checks() result - a flat list
// of heterogeneous check dicts (category_sum_check, platform_sum_check,
// category_label_collision_check, ...), see that module for the exact
// per-check-type fields. Rendered generically (label/status/target/platform/
// diff%/note) rather than one component per check_type, since the fields
// that matter for spotting a real mismatch (diff_pct, note) are common to
// all of them.

import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

const STATUS_SEVERITY = { ok: 'success', mismatch: 'danger', error: 'danger' };

const statusBody = (row) => <Tag value={row.status} severity={STATUS_SEVERITY[row.status] || 'info'} />;

const diffPctBody = (row) => (row.diff_pct === null || row.diff_pct === undefined ? '' : `${(row.diff_pct * 100).toFixed(3)}%`);

const noteBody = (row) => {
  if (row.note) return row.note;
  if (row.collisions && row.collisions.length > 0) {
    return row.collisions.map((c) => c.variants.join(' / ')).join('; ');
  }
  return '';
};

const ControlChecksPanel = ({ result }) => {
  if (!result) return <p className="cr-muted-text">No control checks yet - run Calculate first.</p>;
  if (result.error) return <div className="ex-inline-error">Control checks failed to run: {result.error}</div>;

  return (
    <div>
      <div className="cr-summary-line">
        <span className="cr-muted-value">Overall</span>
        <Tag
          value={result.overall_status}
          severity={STATUS_SEVERITY[result.overall_status] || 'info'}
        />
      </div>
      <DataTable value={result.checks} size="small" showGridlines stripedRows paginator rows={15}>
        <Column field="label" header="Check" />
        <Column body={statusBody} header="Status" />
        <Column field="target" header="Target" />
        <Column field="platform" header="Originator" />
        <Column body={diffPctBody} header="Diff %" headerClassName="cr-num" bodyClassName="cr-num" />
        <Column body={noteBody} header="Note" />
      </DataTable>
    </div>
  );
};

export default ControlChecksPanel;
